import { render, staticRenderFns } from "./new_label.vue?vue&type=template&id=71bb5d61&scoped=true"
import script from "./new_label.vue?vue&type=script&lang=js"
export * from "./new_label.vue?vue&type=script&lang=js"
import style0 from "./new_label.vue?vue&type=style&index=0&id=71bb5d61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb5d61",
  null
  
)

export default component.exports